var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "aftersale-detail" },
    [
      _c("div", { staticClass: "title" }, [
        _c("p", [
          _vm._v("\n      服务编号：" + _vm._s(_vm.as_number) + "("),
          _c("span", [_vm._v(_vm._s(_vm.as_status))]),
          _vm._v(")\n    ")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "table-title" }, [_vm._v("商品信息")]),
      _vm._v(" "),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { data: _vm.aftersaleDetailTableData, border: "" }
        },
        [
          _c("el-table-column", {
            attrs: { label: "锐锢编码" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_vm._v(_vm._s(scope.row.detail[0].ruigu_code))]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "self_code", label: "三方商品编码" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "商品名" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_vm._v(_vm._s(scope.row.detail[0].name))]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "规格" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_vm._v(_vm._s(scope.row.detail[0].spec))]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "单位" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_vm._v(_vm._s(scope.row.detail[0].unit))]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "applied_num", label: "申请数量" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "received_num", label: "收货数量" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("el-input", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showReceiveAccept,
                          expression: "showReceiveAccept"
                        }
                      ],
                      model: {
                        value: scope.row.received_num,
                        callback: function($$v) {
                          _vm.$set(scope.row, "received_num", $$v)
                        },
                        expression: "scope.row.received_num"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.showReceiveAccept,
                            expression: "!showReceiveAccept"
                          }
                        ]
                      },
                      [_vm._v(_vm._s(scope.row.received_num))]
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "accepted_num", label: "确认数量" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("el-input", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showEditAccept,
                          expression: "showEditAccept"
                        }
                      ],
                      model: {
                        value: scope.row.accepted_num,
                        callback: function($$v) {
                          _vm.$set(scope.row, "accepted_num", $$v)
                        },
                        expression: "scope.row.accepted_num"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.showEditAccept,
                            expression: "!showEditAccept"
                          }
                        ]
                      },
                      [_vm._v(_vm._s(scope.row.accepted_num))]
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "returned_num", label: "出库数量" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("el-input", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showReturnAccept,
                          expression: "showReturnAccept"
                        }
                      ],
                      model: {
                        value: scope.row.returned_num,
                        callback: function($$v) {
                          _vm.$set(scope.row, "returned_num", $$v)
                        },
                        expression: "scope.row.returned_num"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.showReturnAccept,
                            expression: "!showReturnAccept"
                          }
                        ]
                      },
                      [_vm._v(_vm._s(scope.row.returned_num))]
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "remark",
              label: "异常原因",
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("el-input", {
                      attrs: { "show-overflow-tooltip": "" },
                      model: {
                        value: scope.row.remark,
                        callback: function($$v) {
                          _vm.$set(scope.row, "remark", $$v)
                        },
                        expression: "scope.row.remark"
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "remarkOverflow" }, [
                      _vm._v(_vm._s(scope.row.remark))
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.showReturnAccept
        ? _c(
            "div",
            [
              _c("h4", [_vm._v("物流信息")]),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  staticStyle: { width: "60%" },
                  attrs: { data: _vm.tsData, border: "" }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "courier_code",
                      label: "物流承运商",
                      width: "145"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    effect: "light",
                                    content:
                                      "按照选项[物流承运商]录入。若需录入的物流承运商在档案中没有，请提供给系统管理员维护。",
                                    placement: "bottom"
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "el-icon-question" },
                                    [_vm._v("物流承运商")]
                                  )
                                ]
                              )
                            ]
                          }
                        },
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-select",
                                {
                                  attrs: { size: "mini", filterable: "" },
                                  model: {
                                    value: scope.row.courier_code,
                                    callback: function($$v) {
                                      _vm.$set(scope.row, "courier_code", $$v)
                                    },
                                    expression: "scope.row.courier_code"
                                  }
                                },
                                _vm._l(_vm.tsList, function(item) {
                                  return _c("el-option", {
                                    key: item.provider_code,
                                    attrs: {
                                      label: item.provider_name,
                                      value: item.provider_code + ""
                                    }
                                  })
                                }),
                                1
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      715786125
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "courier_number", label: "物流运单号" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    effect: "light",
                                    placement: "bottom"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "content" },
                                      slot: "content"
                                    },
                                    [
                                      _c("div", [
                                        _vm._v("a.将单元格格式设置为文本；")
                                      ]),
                                      _vm._v(" "),
                                      _c("div", [
                                        _vm._v(
                                          "\n                b.若一个单据存在多个运单号，请用半角英文状态下的逗号“,”隔开。\n              "
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "el-icon-question" },
                                    [_vm._v("物流运单号")]
                                  )
                                ]
                              )
                            ]
                          }
                        },
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "div",
                                [
                                  _c("el-input", {
                                    attrs: {
                                      type: "textarea",
                                      autosize: { minRows: 1 },
                                      placeholder:
                                        "多个运单号，请用英文逗号“,”隔开"
                                    },
                                    model: {
                                      value: scope.row.courier_number,
                                      callback: function($$v) {
                                        _vm.$set(
                                          scope.row,
                                          "courier_number",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "scope.row.courier_number"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2352963832
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "courier_mobile", label: "物流联系电话" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    effect: "light",
                                    placement: "bottom"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "content" },
                                      slot: "content"
                                    },
                                    [
                                      _c("div", [
                                        _vm._v("将单元格格式设置为文本")
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "el-icon-question" },
                                    [_vm._v("物流联系电话")]
                                  )
                                ]
                              )
                            ]
                          }
                        },
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "div",
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "100% !important" },
                                    attrs: {
                                      placeholder: "请填写物流联系电话",
                                      size: "small"
                                    },
                                    model: {
                                      value: scope.row.courier_mobile,
                                      callback: function($$v) {
                                        _vm.$set(
                                          scope.row,
                                          "courier_mobile",
                                          $$v
                                        )
                                      },
                                      expression: "scope.row.courier_mobile"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      225679580
                    )
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-button",
        {
          attrs: { type: "primary", size: "small" },
          on: {
            click: function($event) {
              return _vm.saveDetail("open")
            }
          }
        },
        [_vm._v("保存")]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "确认提示",
            visible: _vm.dialogVisible,
            center: "",
            "append-to-body": "",
            width: "500px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _vm.showReturnAccept
            ? _c("div", { staticStyle: { "text-align": "center" } }, [
                _c("h4", [_vm._v("请确认信息")]),
                _vm._v(" "),
                _c("h4", { staticStyle: { color: "red" } }, [
                  _vm._v("注：一旦保存，无法再修改。")
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.showEditAccept && _vm.asType === "3"
            ? _c("div", { staticStyle: { "text-align": "center" } }, [
                _c("h4", [_vm._v("请确认进入维修中")])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.showEditAccept && _vm.asType === "1"
            ? _c("div", { staticStyle: { "text-align": "center" } }, [
                _c(
                  "div",
                  { staticStyle: { "margin-bottom": "20px" } },
                  [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          display: "inline-block",
                          "margin-right": "15px"
                        }
                      },
                      [_vm._v("售后责任方")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-radio-group",
                      {
                        model: {
                          value: _vm.freight_bearer,
                          callback: function($$v) {
                            _vm.freight_bearer = $$v
                          },
                          expression: "freight_bearer"
                        }
                      },
                      [
                        _c("el-radio", { attrs: { label: 3 } }, [
                          _vm._v("客户")
                        ]),
                        _vm._v(" "),
                        _c("el-radio", { attrs: { label: 1 } }, [
                          _vm._v("其他")
                        ])
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("p", { staticStyle: { color: "red" } }, [
                  _vm._v("（确认信息，将作为退款处理的依据）")
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.showReceiveAccept
            ? _c("div", { staticStyle: { "text-align": "center" } }, [
                _c("h4", [_vm._v("请确认已收到商品")])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.dialogVisible = false
                    }
                  }
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.saveDetail("close")
                    }
                  }
                },
                [_vm._v("确认")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-51b9691a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51b9691a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/bigAftersale/aftersale-detail.vue
// module id = null
// module chunks = 